/**
 * Format a JS Date into 'YYYY-MM-DDTHH:mm' in local time
 * for use in <input type="datetime-local" />
 */
export const toLocalInputValue = (d) =>
  new Date(d.getTime() - d.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);

export const formatDate = (ts) => {
  if (!ts) return "-";

  try {
    // Case 1: Firestore timestamp object
    if (typeof ts === "object" && "_seconds" in ts) {
      return new Date(ts._seconds * 1000).toLocaleDateString("en-MY", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }

    // Case 2: Valid ISO string
    const d = new Date(ts);
    if (!isNaN(d)) {
      return d.toLocaleDateString("en-MY", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }

    // Case 3: Fallback → manually parse human-readable string
    const parsed = Date.parse(ts.replace("at", ""));
    if (!isNaN(parsed)) {
      return new Date(parsed).toLocaleDateString("en-MY", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }

    return "-";
  } catch {
    return "-";
  }
};

export function fromFirestoreTimestamp(ts) {
  if (!ts) return null;

  try {
    // Firestore v8 format
    if (typeof ts === "object" && "_seconds" in ts) {
      const sec = ts._seconds;
      const nano = ts._nanoseconds || 0;
      return new Date(sec * 1000 + Math.floor(nano / 1e6));
    }

    // Firestore v9 format
    if (typeof ts === "object" && "seconds" in ts) {
      const sec = ts.seconds;
      const nano = ts.nanoseconds || 0;
      return new Date(sec * 1000 + Math.floor(nano / 1e6));
    }

    // ISO string or fallback
    const d = new Date(ts);
    if (!isNaN(d.getTime())) return d;

    return null;
  } catch {
    return null;
  }
}

export function formatDateTime(ts) {
  const jsDate = fromFirestoreTimestamp(ts);
  if (!jsDate) return "-";

  const dateStr = jsDate.toLocaleDateString("en-GB"); // DD/MM/YYYY
  const timeStr = jsDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${dateStr}, ${timeStr}`;
}